<template>
  <TripsMarker :coordinates="coordinates" foreground>
    <IconTripsStopMarker width="50" height="60" />
  </TripsMarker>
</template>

<script>
import TripsMarker from '@/components/trip-detail/maplib/TripsMarker'
import IconTripsStopMarker from '@/components/icons/icon-trips-stop-marker.svg'

export default {
  components: {
    TripsMarker,
    IconTripsStopMarker,
  },
  props: {
    coordinates: {
      type: Object,
      required: true,
    }
  },
}
</script>
